import { Link, Outlet } from "react-router-dom";
import { FaCog, FaEnvelope, FaImage } from "react-icons/fa";

const SystemSettings = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 flex items-center">
        <FaCog className="mr-2" /> Cài đặt Hệ thống
      </h2>
      <p className="text-gray-600 mb-4">Quản lý các cài đặt hệ thống, bao gồm quy tắc, giới hạn và server mail.</p>

      <div className="grid grid-cols-1 gap-4">
        <Link
          to="email-config"
          className="bg-teal-500 text-white p-4 rounded-lg hover:bg-teal-600 transition duration-200 flex items-center space-x-4"
        >
          <FaEnvelope className="text-2xl" />
          <div>
            <h3 className="text-md font-semibold">Cấu hình Server Mail</h3>
            <p className="text-xs">Thiết lập SMTP để gửi email thông báo</p>
          </div>
        </Link>
        <Link
          to="general-settings"
          className="bg-gray-500 text-white p-4 rounded-lg hover:bg-gray-600 transition duration-200 flex items-center space-x-4"
        >
          <FaCog className="text-2xl" />
          <div>
            <h3 className="text-md font-semibold">Cài đặt Chung</h3>
            <p className="text-xs">Cấu hình các quy tắc và giới hạn hệ thống</p>
          </div>
        </Link>
        <Link
          to="photo-storage-settings"
          className="bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition duration-200 flex items-center space-x-4"
        >
          <FaImage className="text-2xl" />
          <div>
            <h3 className="text-md font-semibold">Cài đặt Lưu trữ Ảnh</h3>
            <p className="text-xs">Chọn nơi lưu trữ ảnh (máy chủ cục bộ hoặc Cloudinary)</p>
          </div>
        </Link>
      </div>

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
};

export default SystemSettings;